import profile from "../../api/profile";
import { perPageCount } from "@/common/constants";
import { dummyRows, convertCount } from "@/common/functions";

const getDefaultState = () => {
  return {
    userData: {},
    billingHistory: [],
    totalBillData: 0,
    loaded: false,
    filter: {
      page: 1,
      per_page_count: perPageCount,
    },
    pixelFilter: {
      page: 1,
      per_page_count: perPageCount,
    },
    pixelLoaded: false,
    totalPixelData: 0,
    pixelItems: [],
    domainList: [],
  };
};

// initial state
const state = getDefaultState();
const getters = {
  getItems: (state) => {
    if (!state.billingHistory.length && !state.loaded) {
      return dummyRows();
    }
    return state.billingHistory.map((item) => {
      var currency = item.currency === 1 ? "₹ " : "$";
      return {
        id: item.id,
        name: { invoiceNo: item.invoiceNo, id: item.id },
        date: item.billDate,
        total: currency + convertCount(item.grantTotal),
        status: item.status,
        download: false,
        action: { name: item.invoiceNo, id: item.id },
      };
    });
  },
  getPixelItems: (state) => {
    if (!state.pixelItems.length && !state.pixelLoaded) {
      return dummyRows();
    }
    return state.pixelItems.map((item) => {
      return {
        id: item.encId,
        name: { title: item.title, id: item.encId },
        type: item.pixelType,
        pixel: item.trackingCode,
        alternateParams: item.alternateParams,
        status: item.status,
        domain: item.trackingDomain,
        _showDetails: item._showDetails,
        action: item.encId,
      };
    });
  },
  getDomainList: (state) => {
    return state.domainList.map((item) => {
      return {
        value: item,
        label: item,
      };
    });
  },
};

// actions
const actions = {
  fetchDetails() {
    return profile.fetchDetails();
  },
  uploadProfilePic(_, params) {
    return profile.uploadProfilePic(params);
  },
  removeProfilePic(_, params) {
    return profile.removeProfilePic(params);
  },
  updateUserData(_, params) {
    return profile.updateUserData(params);
  },
  updateCompanyData(_, params) {
    return profile.updateCompanyData(params);
  },
  updateAddressData(_, params) {
    return profile.updateAddressData(params);
  },
  updateBillData(_, params) {
    return profile.updateBillData(params);
  },
  changePassword(_, params) {
    return profile.changePassword(params);
  },
  setUserData({ commit }, params) {
    commit("setUserData", params);
  },
  fetchBillingHistory({ commit, state }, params) {
    var filter = state.filter;
    if (
      !state.loaded ||
      filter.page !== params.page ||
      filter.per_page_count !== params.per_page_count
    ) {
      commit("setFilter", { ...params });
      profile.fetchBillingHistory(params, (data) => {
        commit("setBillingHistory", { items: data.items });
        commit("setTotalBillData", data.total);
        commit("setLoaded", true);
      });
    }
  },
  refreshBillingHistory({ commit, dispatch }) {
    commit("setLoaded", false);
    dispatch("fetchBillingHistory");
  },
  updateQuota(_, params) {
    return profile.updateQuota(params);
  },
  fetchPixelList({ commit, state }, params) {
    var filter = state.pixelFilter;
    if (
      !state.pixelLoaded ||
      filter.page !== params.page ||
      filter.per_page_count !== params.per_page_count
    ) {
      commit("setPixelFilter", { ...params });
      profile.fetchPixelList(params, (data) => {
        commit("setPixelList", { items: data.items });
        commit("setTotalPixelData", data.total);
        commit("setPixelLoaded", true);
      });
    }
  },
  refreshPixelList({ commit, dispatch }) {
    commit("setPixelLoaded", false);
    dispatch("fetchPixelList");
  },
  fetchDomainList({ commit, state }) {
    if (!state.domainList.length) {
      profile.fetchDomainList((data) => {
        commit("setDomainList", data);
      });
    }
  },
  generatePixel(_, params) {
    return profile.generatePixel(params);
  },
  deletePixel(_, params) {
    return profile.deletePixel(params);
  },
  fetchInvoiceDetails(_, params) {
    return profile.fetchInvoiceDetails(params);
  },
  downloadInvoice(_, params) {
    return profile.downloadInvoice(params);
  },
  resetState({ commit }) {
    commit("resetState");
  },
};

// mutations
const mutations = {
  setUserData(state, userData) {
    state.userData = userData;
  },
  setBillingHistory(state, { items }) {
    state.billingHistory = items;
  },
  setTotalBillData(state, total) {
    state.totalBillData = total;
  },
  setLoaded(state, loaded) {
    state.loaded = loaded;
  },
  setPixelList(state, { items }) {
    state.pixelItems = items;
  },
  setTotalPixelData(state, total) {
    state.totalPixelData = total;
  },
  setPixelLoaded(state, loaded) {
    state.pixelLoaded = loaded;
  },
  setDomainList(state, data) {
    state.domainList = data;
  },
  setPixelFilter(state, data) {
    state.pixelFilter = data;
  },
  setFilter(state, data) {
    state.filter = data;
  },
  resetState(state) {
    Object.assign(state, getDefaultState());
  },
};
export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
